<template>
  <div class="col-lg-4 col-12 col-md-6 card-col">
    <div class="card-ct card-rounded-shadowed">
      <div class="user-profile-section">
        <div class="avatar">
          <div class="placeholder yellow">{{getAbbr()}}</div>
        </div>
        <div class="user-details">
          <div class="name">{{user ? user.name : ''}}</div>
          <div class="status">{{formatLevel()}}</div>
        </div>
        <div class="user-stats">
          <div class="points">{{user ? user.credit : null}} <small>{{$t('achievements_points')}}</small></div>
        </div>
      </div>
      <div class="achievements-section">
        <div class="text-center" v-if="spinners.contentIsLoading">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-for="achievement in achievements" class="achievement" :class="achievement.isHighlighted ? 'highlighted' : ''" :key="achievement.id">
          <div class="d-flex">
            <div class="achchievement-icon">
              <img :src="achievement.imagePath" :alt="achievement.texts.title">
            </div>
            <div class="achievement-details">
              <h4>{{ achievement.texts.title }}</h4>
              <p>{{ achievement.texts.subtitle }}</p>
              <div class="progress-ct">
                <div v-if="!achievement.isHighlighted" class="progress-bar-ct" :style="achievement.colorHex | rgbaBackground">
                  <div :style="'width: ' + getProgressPercent(achievement.progress, achievement.goal) + '%; background: ' + achievement.colorHex + ';'" class="bar"></div>
                </div>
                <div v-else class="progress-bar-ct">
                  <div :style="'width: ' + getProgressPercent(achievement.progress, achievement.goal) + '%;'" class="bar"></div>
                </div>
                <div class="counter">{{ achievement.progress }}/{{ achievement.goal }}</div>
              </div>
            </div>
          </div>
          <div class="achievement-description">
            <div class="text">
              <p>{{ achievement.texts.description }}</p>
            </div>
            <div class="action">
              <a href="#"
                 class="btn btn-primary btn-xs"
                 :class="!hasSufficientCredits(achievement) ? 'disabled' : ''"
                 @click="openConfirmModal(achievement, $event)">{{ $t('achievements_exchange') }}</a>
            </div>
          </div>
        </div>
        <b-modal
          :title="$t('achievements_exchange_points_for_goods')"
          @hide="onConfirmModalClose"
          @close="onConfirmModalClose"
          ref="modal-confirm">
          <template v-slot:default>
            <p v-if="!confirmModalAchievementCode">{{$t('achievements_exchange_modal_text')}}</p>
            <div v-if="confirmModalError" class="alert alert-danger" role="alert">
              {{ confirmModalError }}
            </div>
            <div class="row" v-if="confirmModalAchievementCode">
              <div class="col-12" v-if="confirmModalAchievementCode === 'charity'">
                <p class="h5">{{ $t('achievements_exchange_modal_charity_success_text') }}</p>
              </div>
              <div class="col-12" v-else>
                <p class="h6">{{ $t('achievements_exchange_modal_code_text') }}</p>
                <div class="badge badge-primary">
                  <p class="h5 m-0 px-2 py-1"><span>{{ confirmModalAchievementCode }}</span></p>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:modal-footer>
            <button type="button" class="btn btn-light px-4 py-2" @click="closeConfirmModal()">{{$t('modal_close')}}</button>
            <button type="button"
                      class="btn btn-primary px-4 py-2"
                      @click="submitConfirmModal()"
                      v-if="!confirmModalAchievementCode">
              <b-spinner v-if="spinners.submitting" variant="light"/>
              <span v-else>{{$t('modal_submit')}}</span>
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import AchievementsMixin from '@/mixins/AchievementsMixin';
import statuses from '@/store/statuses';

export default {
  props: ["user"],
  components: {},
  mixins: [ AchievementsMixin ],
  data () {
    return {};
  },
  mounted () {
    this.getData();
  },
  computed: {},
  watch: {
    achievementsProgress: {
      handler() {
        if (this.achievementsProgress.status === statuses.LOADED) {
          this.fillData(3);
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    achievementsClaim: {
      handler() {
        if (this.achievementsClaim.status === statuses.LOADED) {
          this.confirmModalAchievementCode = this.achievementsClaim.data.data.code;
          this.alertSuccess();
          this.getData();
          this.onClaimSuccess();
        } else if (this.achievementsClaim.status === statuses.ERROR) {
          if (this.achievementsClaim.data.data.exception) {
            this.confirmModalError = this.$t('notify_error_default_title');
          } else {
            this.confirmModalError = this.achievementsClaim.data.data.error[0];
          }
          this.alertError();
        }

        this.spinners.submitting = false;
      }
    }
  },
  methods: {
    getAbbr () {
      if (this.user && this.user.name) {
        let abbreviation = '';
        this.user.name.split(' ').forEach((word) => {abbreviation += word.charAt(0)});
        return abbreviation
      } else {
        return '';
      }
    },
    formatLevel () {
      let start = this.$t('homescreen_achievements_pre_level_text');
      if (start === 'homescreen_achievements_pre_level_text') {
        start = '';
      }
      let end = this.$t('homescreen_achievements_post_level_text');
      if (end === 'homescreen_achievements_post_level_text') {
        end = '';
      }
      return start + (this.user ? this.user.user_level : 1) + end; 
    },
    onClaimSuccess () {
      this.$emit('claimSuccess');
    }
  }
}
</script>

<style scoped>
</style>
